import React from 'react';
import PropTypes from 'prop-types';
import Loader from '@/components/common/Loader';
import { LazyDialog } from '@/modules/Dialogs';
import lazyWithRetry from '@/utils/lazyWithRetry';

const LinkToPledgeDialogContent = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "link-to-pledge-dialog" */
    '@/components/common/contribution/LinkToPledgeDialogContent'
  ),
);

export default function LinkToPledgeDialog({
  constituentId,
  displayName,
  donationId,
  onClose,
  ...dialogProps
}) {
  const fallback = <Loader isCentered />;

  return (
    <React.Suspense fallback={fallback}>
      <LazyDialog
        scroll="paper"
        maxWidth="md"
        onClose={onClose}
        {...dialogProps}
      >
        <LinkToPledgeDialogContent
          constituentId={constituentId}
          displayName={displayName}
          onClose={onClose}
          donationId={donationId}
        />
      </LazyDialog>
    </React.Suspense>
  );
}

LinkToPledgeDialog.propTypes = {
  constituentId: PropTypes.string,
  displayName: PropTypes.string,
  onClose: PropTypes.func,
  donationId: PropTypes.string,
};

LinkToPledgeDialog.defaultProps = {
  constituentId: null,
  displayName: null,
  onClose: null,
  donationId: null,
};
